import { RenderersType } from "@home-health-notify/domain";
import {
  and,
  RankedTester,
  rankWith,
  schemaTypeIs,
  uiTypeIs,
} from "@jsonforms/core";

export const arrayLayoutTester: RankedTester = rankWith(
  5,
  and(schemaTypeIs("array"), uiTypeIs(RenderersType.StaticArrayLayout)),
);
